module.exports = __webpack_public_path__ + "static/media/dashboard_picture.91689d53.png";